import { z } from 'zod';

/** Identifiers are UUIDs. */
export const idSchema = z.uuid();

/** RFC 9457 problem details with a stable `code` and the correlation id (`@bloom/http`). */
export const problemIssueSchema = z.object({
  path: z.string(),
  message: z.string(),
  code: z.string().optional(),
});
export type ProblemIssue = z.infer<typeof problemIssueSchema>;

export const problemSchema = z.object({
  type: z.string().optional(),
  title: z.string().optional(),
  status: z.number().int().optional(),
  code: z.string().optional(),
  detail: z.string().optional(),
  correlationId: z.string().optional(),
  errors: z.array(problemIssueSchema).optional(),
});
export type Problem = z.infer<typeof problemSchema>;

export const pageMetaSchema = z.object({
  page: z.number().int(),
  pageSize: z.number().int(),
  total: z.number().int(),
  totalPages: z.number().int(),
});
export type PageMeta = z.infer<typeof pageMetaSchema>;

/** `{ data, meta }`: the shape of every paginated list. */
export function pageOf<T extends z.ZodType>(item: T) {
  return z.object({ data: z.array(item), meta: pageMetaSchema });
}

export interface Page<T> {
  readonly data: readonly T[];
  readonly meta: PageMeta;
}

/** `{ data }`: the shape of an unpaginated list. */
export function listOf<T extends z.ZodType>(item: T) {
  return z.object({ data: z.array(item) });
}
